/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface ICreateAsynchronousPaymentButtonProps {
    buttonLabel: string;
    onClick(event: React.MouseEvent<HTMLButtonElement>): void;
    disabled?: boolean;
    canGenerate?: boolean;
    ariaLabel?: string;
    telemetryContent?: ITelemetryContent;
    className?: string;
}

/**
 * CreateAsynchronousPaymentButton.
 * @param root0.canGenerate
 * @param root0.buttonLabel
 * @param root0.ariaLabel
 * @param root0.disabled
 * @param root0.telemetryContent
 * @param root0.onClick
 * @extends {React.FC<CreateAsynchronousPaymentButton>}
 */
const CreateAsynchronousPaymentButton: React.FC<ICreateAsynchronousPaymentButtonProps> = ({
    buttonLabel,
    ariaLabel,
    telemetryContent,
    disabled = false,
    canGenerate = true,
    onClick,
    className = 'ms-create-asynchronous-payment__button'
}) => {
    const payload = getPayloadObject('click', telemetryContent!, '');
    const attribute = getTelemetryAttributes(telemetryContent!, payload);

    return (
        <button
            type='button'
            className={className}
            onClick={onClick}
            aria-label={ariaLabel}
            disabled={disabled || !canGenerate}
            {...attribute}
        >
            {buttonLabel}
        </button>
    );
};
export default CreateAsynchronousPaymentButton;
